import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { useAuth } from './useAuth';

export interface IAnnouncement {
	id: string;
	title: string;
	text: string;
	type: 'announcement' | 'info';
}

const useAnnouncements = () => {
	const { session } = useAuth();

	const getAnnouncements = async (): Promise<IAnnouncement[]> => {
		const response = await axios.get(
			`${import.meta.env.VITE_API_HOST}/api/v1/announcements`,
			{
				headers: { Authorization: session?.tokenized },
			},
		);

		return response.data;
	};

	return useQuery({
		queryKey: ['announcements'],
		queryFn: () => getAnnouncements(),
		enabled: !!session?.tokenized,
	});
};

export default useAnnouncements;
